export const getDomain = () => {
  return window.location.hostname.split('.').splice(-2).join('.')
}
